@if (team) {
  <div class="option-header" [formGroup]="lockedTasksFormGroup" [dtOverlayProgress]="false" #optionSaveProgress="dtOverlayProgress">
    <button mat-raised-button color="accent" (click)="assignTask()"><mat-icon>add</mat-icon> <span i18n>Aufgabe verteilen</span></button>
    <mat-slide-toggle formControlName="lockedWeightTasks" i18n>Zielgewichtsaufgaben sperren</mat-slide-toggle>
    <mat-slide-toggle formControlName="lockedOpinionTasks" i18n>Meinungsaufgaben sperren</mat-slide-toggle>
  </div>
}

@if (team) {
  <dt-team-task-list
    [tasks]="allTasks"
    [team]="team"
    [teamCalc]="teamCalc"
    [shownColumns]="['type', 'assignedTo', 'created', 'modified', 'state']"
    defaultSortDirection="desc"
  ></dt-team-task-list>
}

@if (!team) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}
